import styles from './CustomDomainBootScreen.module.css'

export function CustomDomainBootScreen() {
  return <p className={styles.message}>Carregando campanha…</p>
}
